import { useEffect, useState } from 'react';
// import axios from '@/services/axiosInstance';
import axiosInstance from "../helpers/Axios";

type Props = {
  tabName: string; // ex: "description", "horaires", "ecoles"
};

const TabImage = ({ tabName }: Props) => {
  const [src, setSrc] = useState<string | null>(null);

  useEffect(() => {
    const loadImage = async () => {
      const res = await axiosInstance.get('/image');

      const folder = res.data.find(
        (f: any) => f.name === 'courses'
      );

      if (!folder?.files) return;

      const file = folder.files.find((f: string) =>
        f.startsWith(tabName + '.')
      );

      if (file) {
        setSrc(
          `${import.meta.env.VITE_BACKEND_URL}/images/courses/${file}`
        );
      }
    };

    loadImage();
  }, [tabName]);

  if (!src) return null;

  return (
    <div className="tab-image">
      <img
        src={src}
        alt={tabName}
        loading="lazy"
      />
    </div>
  );
};

export default TabImage;